import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ExpiredControlSearchRequest, ExpiredControlSend311Request } from 'src/app/core/models/transport-operation/expired-control-request';
import { ExpiredControlSearchResponse, ExpiredControlSend311Response } from 'src/app/core/models/transport-operation/expired-control-response';

@Injectable({
  providedIn: 'root'
})
export class ExpiredControlService {

  constructor(private http: HttpClient) { }

  searchExpiredInventory(req: ExpiredControlSearchRequest): Observable<ExpiredControlSearchResponse> {
    const url = `${environment.logisticsApiUrl}/inventory/searchExpiredInventory`;
    return this.http.post<ExpiredControlSearchResponse>(url, req);
  }

  send311ExpiredInventory(req: ExpiredControlSend311Request): Observable<ExpiredControlSend311Response> {
    const url = `${environment.logisticsApiUrl}/inventory/getExpiredInventoryRequest`;
    return this.http.post<ExpiredControlSend311Response>(url, req);
  }
}
